const title = (t) => {
  const postfix = "XLNTbrain-Cog Test";
  return (t ? [t, postfix] : [postfix]).join(" - ");
};

export default title;
